import _ from 'lodash';

import { getContactsOptionLabelCallback } from '../../../Activities.utils';

export const normalizeFreeSoloValue = values =>
  values.map(item => (_.isString(item) ? { label: item.trim(), value: item.trim() } : item));

export const getOptionLabelSafe = option =>
  _.isString(option) ? option : getContactsOptionLabelCallback(option);

export const isDuplicateEmail = (email, allRecipients) =>
  allRecipients.some(existing => existing.value.toLowerCase() === email.toLowerCase());
